/* GARDEN EQUIPMENT — Panier latéral AJAX (reproduction CartDrawer.tsx) */
(function () {
  "use strict";

  var root = document.querySelector("[data-ge-cart]");
  if (!root) return;

  var itemsEl = root.querySelector("[data-ge-cart-items]");
  var emptyEl = root.querySelector("[data-ge-cart-empty]");
  var footEl = root.querySelector("[data-ge-cart-foot]");
  var subtitleEl = root.querySelector("[data-ge-cart-subtitle]");
  var totalEl = root.querySelector("[data-ge-cart-total]");
  var badgeEl = root.querySelector(".ge-cart__sub-badge");
  var badgeTTC = badgeEl ? badgeEl.textContent : "";
  var busy = false;

  /* Mode pro : prix unitaire = tarif pro HT (propriété de ligne _pro_unit_ht) posé à l'ajout. */
  function isPro() { return document.documentElement.classList.contains("ge-is-pro"); }
  function isB2B() { return document.documentElement.classList.contains("ge-is-b2b"); }
  function unitCents(it) {
    if (isPro() && it.properties && it.properties._pro_unit_ht) {
      var v = parseFloat(it.properties._pro_unit_ht);
      if (isFinite(v) && v > 0) return Math.round(v * 100);
    }
    return it.final_price;
  }

  function money(cents) {
    try {
      return (cents / 100).toLocaleString("fr-FR", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR" });
    } catch (e) {
      return (cents / 100).toFixed(2) + " €";
    }
  }

  function esc(s) {
    return (s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function updateBubbles(count) {
    document.querySelectorAll("[data-ge-cart-count]").forEach(function (b) {
      b.textContent = count;
      b.classList.toggle("is-empty", count === 0);
    });
  }

  function render(cart) {
    var count = cart.item_count;
    updateBubbles(count);
    if (subtitleEl) subtitleEl.textContent = count === 0 ? "Votre panier est vide" : count + (count > 1 ? " articles" : " article");

    if (count === 0) {
      itemsEl.innerHTML = "";
      if (emptyEl) emptyEl.style.display = "";
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.style.display = "none";
    if (footEl) footEl.hidden = false;
    if (totalEl) {
      var totalCents = isPro()
        ? cart.items.reduce(function (s, it) { return s + unitCents(it) * it.quantity; }, 0)
        : cart.total_price;
      totalEl.textContent = money(totalCents);
    }
    if (badgeEl) badgeEl.textContent = isPro() ? "HT" : badgeTTC;

    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var line = i + 1;
      var opts = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== "Default Title"; })
        .map(function (o) { return esc(o.value); }).join(" • ");
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") + '" alt="' + esc(it.product_title) + '">' : "";
      return (
        '<div class="ge-cart__item" data-line="' + line + '">' +
          '<div class="ge-cart__item-img">' + img + "</div>" +
          '<div class="ge-cart__item-main">' +
            '<p class="ge-cart__item-title">' + esc(it.product_title) + "</p>" +
            (opts ? '<p class="ge-cart__item-opts">' + opts + "</p>" : "") +
            '<p class="ge-cart__item-price">' + money(unitCents(it)) + (isPro() || isB2B() ? " HT" : "") + "</p>" +
          "</div>" +
          '<div class="ge-cart__item-side">' +
            '<button type="button" class="ge-cart__rm" data-ge-remove aria-label="Retirer">&#128465;</button>' +
            '<div class="ge-cart__qty">' +
              '<button type="button" class="ge-cart__qbtn" data-ge-dec aria-label="Moins">&minus;</button>' +
              '<span class="ge-cart__qval">' + it.quantity + "</span>" +
              '<button type="button" class="ge-cart__qbtn" data-ge-inc aria-label="Plus">+</button>' +
            "</div>" +
          "</div>" +
        "</div>"
      );
    }).join("");
  }

  function refresh() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function change(line, quantity) {
    if (busy) return;
    busy = true;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .finally(function () { busy = false; });
  }

  function open() { root.classList.add("is-open"); root.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; refresh(); }
  function close() { root.classList.remove("is-open"); root.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }

  /* Ouvre au clic sur l'icône panier du header */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("#cart-icon-bubble, [data-ge-cart-open]");
    if (trigger) { e.preventDefault(); open(); return; }
    if (e.target.closest("[data-ge-cart-close]")) { e.preventDefault(); close(); return; }

    var item = e.target.closest(".ge-cart__item");
    if (item) {
      var line = parseInt(item.getAttribute("data-line"), 10);
      var qty = parseInt(item.querySelector(".ge-cart__qval").textContent, 10);
      if (e.target.closest("[data-ge-inc]")) return change(line, qty + 1);
      if (e.target.closest("[data-ge-dec]")) return change(line, Math.max(0, qty - 1));
      if (e.target.closest("[data-ge-remove]")) return change(line, 0);
    }

    if (e.target.closest("[data-ge-cart-checkout]")) { window.location.href = "/checkout"; }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root.classList.contains("is-open")) close();
  });

  /* Intercepte les ajouts au panier (formulaires product) → ouvre le tiroir */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var data = new FormData(form);
    fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: data })
      .then(function (r) { return r.json(); })
      .then(function () { open(); });
  });

  /* Initialise le compteur au chargement */
  refresh();
})();
